export default [
  {
    path: '/paychecks',
    name: 'paychecks',
    component: () => import('./Paychecks.vue'),
    meta: {
      requiresAuth: true,
      name: 'Contracheques',
    },
  },
]
